import dayjs from "dayjs"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { GetEnrolmentAutomatedCommunicationByIdQuery } from "@/api/hasura/generated/graphql"
import { IEnrolmentAutomatedCommunication } from "./enrolmentAutomatedCommunication.types"
import { EnrolmentAutomatedCommunication } from "./enrolmentAutomatedCommunication"

export type IEnrolmentAutomatedCommunicationRaw =
  GetEnrolmentAutomatedCommunicationByIdQuery["enrolment_automated_communications"][0]

export const EnrolmentAutomatedCommunicationParser: IParser<
  IEnrolmentAutomatedCommunication,
  IEnrolmentAutomatedCommunicationRaw
> = {
  toDomain: (rawEnrolmentAutomatedCommunication) => {
    try {
      return new EnrolmentAutomatedCommunication(
        dayjs(rawEnrolmentAutomatedCommunication.created_at),
        rawEnrolmentAutomatedCommunication.enrolment_id,
        rawEnrolmentAutomatedCommunication.paragraph_one ?? "",
        rawEnrolmentAutomatedCommunication.paragraph_two ?? "",
        rawEnrolmentAutomatedCommunication.comms_sent,
        rawEnrolmentAutomatedCommunication.comms_sent_to,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
